import React, { useEffect, useRef } from "react";
import { Eraser } from "lucide-react";

export const SignaturePad = ({ value, onChange, testid }) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ratio = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = Math.max(1, rect.width * ratio);
    canvas.height = Math.max(1, rect.height * ratio);
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#141414";
    if (value) {
      const img = new Image();
      img.onload = () => ctx.drawImage(img, 0, 0, rect.width, rect.height);
      img.src = value;
    }
    // eslint-disable-next-line
  }, []);

  const point = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; last.current = point(e); canvasRef.current.setPointerCapture?.(e.pointerId); };
  const move = (e) => {
    if (!drawing.current) return; e.preventDefault();
    const ctx = canvasRef.current.getContext("2d"); const p = point(e);
    ctx.beginPath(); ctx.moveTo(last.current.x, last.current.y); ctx.lineTo(p.x, p.y); ctx.stroke();
    last.current = p;
  };
  const end = () => { if (!drawing.current) return; drawing.current = false; onChange(canvasRef.current.toDataURL("image/png")); };
  const clear = () => { const c = canvasRef.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); onChange(""); };

  return (
    <div className="relative">
      <canvas
        ref={canvasRef}
        data-testid={testid}
        onPointerDown={start}
        onPointerMove={move}
        onPointerUp={end}
        onPointerLeave={end}
        className="w-full h-36 bg-surfaceSecondary border border-border rounded-[12px] touch-none cursor-crosshair"
      />
      {!value && <span className="absolute inset-0 flex items-center justify-center text-sm text-muted-foreground pointer-events-none">Sign here with your finger</span>}
      <button type="button" data-testid={`${testid}-clear`} onClick={clear} className="absolute top-2 right-2 flex items-center gap-1 text-xs font-semibold text-muted-foreground bg-surface/90 border border-border rounded-full px-2.5 py-1 active:scale-95 transition-transform"><Eraser size={12} /> Clear</button>
    </div>
  );
};
